import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';
import { isString } from 'lodash';

import { TextLine } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { PriceSourceHelper } from 'pricing/helpers';
import { QuotePartColId } from 'quotes/components';
import { externalSellPriceSourceFields } from 'quotes/constants';
import { ExternalPricingSourceTooltip } from 'quotes/elements';
import { pickPricingSourceFields } from 'quotes/utils';
import { Color } from 'theme/enums';

import { PriceSource } from './PriceSource';

const PriceSourceCell = (params: ICellRendererParams) => {
  const data = getAgGridTableCellData(params, QuotePartColId.PRICE_SOURCE);
  if (!data) {
    const displayValue = isString(params?.value) ? params?.value : params?.value[0];

    return <TextLine text={displayValue} bold textEllipsis />;
  }

  const { priceSourceId } = data;

  if (!priceSourceId) {
    return <TextLine text={t('messageNoPrice')} bold />;
  }

  const isGroupedByColumn =
    QuotePartColId.PRICE_SOURCE === params?.node?.rowGroupColumn?.getColId();

  const priceSourceLabel = PriceSourceHelper.getTypeLabel(data);

  if (isGroupedByColumn) {
    return <TextLine text={priceSourceLabel} bold textEllipsis />;
  }

  return (
    <ExternalPricingSourceTooltip
      pricingData={pickPricingSourceFields(data, externalSellPriceSourceFields)}
      isAlternateVersionEnabled={Boolean(data.alternateVersionEnabled)}
      color={Color.SUCCESS}
    >
      <PriceSource priceSource={data} />
    </ExternalPricingSourceTooltip>
  );
};

export default PriceSourceCell;
